// extracted by mini-css-extract-plugin
export default {"login":"LoginForm_login__nFhwy"};